export const results = [
  {
    resultId: 1,
    result: "Sony WH-1000XM4",
    price: "$248",
    imgURL:
      "https://media.wired.com/photos/6180507bf85b5d6b65fa352b/4:3/w_600/",
    url: "https://cna.st/affiliate-link/GxyGifxJVDHw6UM6ovs9NuW5ZmqUgBWUKwX2fqaUH7tmtDr9iksMkcKF8qGDhWdBpfSE7SYJfch1LAyURU3nyuyvsPD6SRL2CUb7vk2W1At7ZZytZvvp9f5GArTqfNeH3peCL8Mzj17xdLpPmXmRheFRCsgcCxxxRVAw5BU8Pivj?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 3,
    result: "Sony WF-1000XM4",
    price: "$248",
    imgURL:
      "https://media.wired.com/photos/60df6c8d3082cb0dcce32b91/4:3/w_600/",
    url: "https://cna.st/affiliate-link/pXmrR9GCMgxApRozVjcH8nMWtAkeUmq4i6twwdcJanB4VBdWzP63Ziom6QVFHyDsL6AKE5XbDqPyhrLjqkWjMqhFD2tJHf5euRiLxdoTHuCAdrGhphzLVvhGC2nwuQ3BdPANHNJcUUfswE4onXbzNeXrzB3zC54SoTm9oSyVq?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 4,
    result: "Apple AirPods Max",
    price: "$479",
    imgURL:
      "https://media.wired.com/photos/6014a6587201ff6c1ba30bcb/4:3/w_600/",
    url: "https://cna.st/affiliate-link/3m18KYZScXJ9R6kfJdAoAZswM3zACwUDAb2yJHNVxZZjWJMR8Z8UTsjzBhZJRp2Qd4BE8hWfL9A3DBTf8CEYR1rdykZfsTnJXHFr8p4Q2r8GAmXoXakAdMmef9e8EF?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 5,
    result: "Apple AirPods Pro",
    price: "$179",
    imgURL:
      "https://media.wired.com/photos/5eac754746ab1415d289bf93/4:3/w_600/",
    url: "https://cna.st/affiliate-link/DBDZJrJC3nig9NPi4neEmE7psWBHdhR6hKDhVHFtpEjUcKb7WLozDcxjQE1ZvWZDG928xyosLfkGnhswcZCqLS3mVnPu3h3DppvJ4nWBkUNQaWmpUo6WJX5zG14jrBr?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 6,
    result: "Samsung Galaxy Buds2",
    price: "$107",
    imgURL:
      "https://media.wired.com/photos/61254bff2b66f759725d4bc0/4:3/w_600/",
    url: "https://cna.st/affiliate-link/8GHpbfKbJFTsDKEvy4yhqvmNVNnQS8q86uWwWou899iEbg5VaxmyiBZHjRY6t8UbJxoFii1mykNzAQsnGShL3UgSKiksfP7SE3f865y9Ls5fHn7ndZMrBeLFhpr7Fusi4z79Dc9dCXgYwefLhAVfp87rNA8MRnihZaKt?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 7,
    result: "Sennheiser HD6XX",
    price: "$220",
    imgURL: "https://media.wired.com/photos/619bf53a1b20fb43d6500ebe/4:3/w_600",
    url: "https://cna.st/affiliate-link/29WcPCBE5CEw5TEQzNutVnYVLEZGctMuiUXEJ5bhJNwFDbAsNmrKXMQ6wcEWiUw8iTU8Mr5Z9Vkv61asU6KkW74nY6M3vYjAxBzQ2WT?cid=618c00090c47ce1547c65368",
    retailer: "Drop",
  },
  {
    resultId: 8,
    result: "Monolith M570 Planar",
    price: "$300",
    imgURL:
      "https://media.wired.com/photos/611fdc9f7ea2ee7b6da6dcd9/4:3/w_600/",
    url: "https://cna.st/affiliate-link/4R1mmfmYGn7qW2iUjHX1TMuYmLNJKJTgo78UoKnFVzopd7BJnUr2nxF3Awr9yGE1TUCp4W998WM52NsjQsBHcaixB15LkvgauNz9?cid=618c00090c47ce1547c65368",
    retailer: "Monoprice",
  },
  {
    resultId: 9,
    result: "Shure SE11-GR",
    price: "$49",
    imgURL: "https://media.wired.com/photos/619bf53b1b20fb43d6500ec0/4:3/w_600",
    url: "https://cna.st/affiliate-link/AqefbiEiZJpETR24rWjDt7rLL7SXU2qPjnAAqFD35VxiMNg5ZDFST3yntDojaMAWsyusAVJgn4UNnnm2KdhcFZoFhCDL3efMHhXijtV7ZpLgrdoYVK5B8Jy9JfCvF2JpYWafeh4KVvbLY1T4y4QvdRGDL?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 10,
    result: "Black Bay Tempo 30",
    price: "$50",
    imgURL:
      "https://media.wired.com/photos/61671523d5b17ced239ac8a8/4:3/w_600/",
    url: "https://cna.st/affiliate-link/7dutxVk9viQe3CFm1DUnko8bpgpF4idaTF1RuRLqJrJXHEC43UQj7bbRixsJuxAECE1JLhydyigHy9pwEVr6Yhx8Voga9ELFotswD5srkLUqUZkg4orX3dZzrbz3kq2EV4QwhGsjpgU1YUF4C74Ze?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 11,
    result: "1More Colorbuds",
    price: "$70",
    imgURL:
      "https://media.wired.com/photos/609327c54e934010a058f6d7/4:3/w_600/",
    url: "https://cna.st/affiliate-link/kRjFND1YRbdUPb1i1YDMrdEkKMRfUK6bMpKUPwi8ArpuWvfV7B4jKz9fX5XGvBzzt2CLQsvbtdYJFYarhPXMG4rBK9LXttsscGqUd48K4ywA7Je6eUtoGJUBmDUWbSi9RMVAQFvT15YWEgu3MZX9uZp4qu?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 12,
    result: "Audio Technica M50XBT",
    price: "$190",
    imgURL:
      "https://media.wired.com/photos/5954644838978176dacc5ad4/4:3/w_600/",
    url: "https://cna.st/affiliate-link/MQqxxtNLXvk4cciCsrKXhKa2gQFRcpuCvtCfbWVpiSmttY2cu8NW3LXBV3Fae3zSmt92iuax9CFU5eLHLVs5ENtkpN?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 13,
    result: "Ultimate Ears Fits",
    price: "$250",
    imgURL:
      "https://media.wired.com/photos/60302878091d7b01b7e2080d/4:3/w_600/",
    url: "https://cna.st/affiliate-link/PLjJJwDSyohfc1kXTDwteGKLomnm55ApbQL3vqQdkoALFHrumjJjdsuGfRjrgVaMFR7xF9xh6FzkNiZhsN2FMbsfuyXKSayzjE3UfqnLJ?cid=618c00090c47ce1547c65368",
    retailer: "Ultimate Ears",
  },
  {
    resultId: 14,
    result: "Jabra Elite 45H",
    price: "$100",
    imgURL: "https://media.wired.com/photos/619bf53ae156bcdd49c86df3/4:3/w_600",
    url: "https://cna.st/affiliate-link/K3zshu2hqgiatzk7HYmdfMKqjTxBx2RtqGCbk2AZoryeHMDXNDRfcX6EBUoeQRBNEK7xDwrkiRhVNqzwv29SYJB8Fj9HVVSqbS7daC5C6JPAdRM5B2T2vi1BRCr8mxs8WmZ?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 15,
    result: "Jabra Elite 7 Active",
    price: "$180",
    imgURL: "https://media.wired.com/photos/619bf53b38a058be95c4b0b5/4:3/w_600",
    url: "https://cna.st/affiliate-link/8GHpbfKbJFTsDKEvy4yhqvmNVNnQS8q86uWwWou899iEbg5VaxmyiBZHn8wyVPSxbYi1PM57ieg9KZ9hmyEBCYrgWsmUqhfpqeok3U25xpfCQFGx8kstmt7v21KPBbZaobVYSVFcuXjJdghYL12Nr1tFyKwNdHySJ3D2?cid=618c00090c47ce1547c65368",
    retailer: "Target",
  },
  {
    resultId: 16,
    result: "Grado SR60X",
    price: "$100",
    imgURL: "https://media.wired.com/photos/61b7bc75c2f5f4d2aaf1c32e/4:3/w_600",
    url: "https://cna.st/affiliate-link/74gALtHrcYhSSXgQtUxpNBeLf8yANWH3u7how4kjHXjT7SwjbkDchaLnmgGAYxK3fCZXS2LcBHK7VUW4Nz2rPgFKJxSMDwa4WX98eZhu5rbHuzT2cfjh3gtUET5km8rQAusJqy?cid=618c00090c47ce1547c65368",
    retailer: "Crutchfield",
  },
  {
    resultId: 17,
    result: "Beats Powerbeats",
    price: "$110",
    imgURL:
      "https://media.wired.com/photos/5b4544bfcc217a0b6be35fdc/4:3/w_600/",
    url: "https://cna.st/affiliate-link/3SWPfB1CZvhbRRTX9TedUqR7kcMS6R5p23Zkh1zfGXJ9m5bwqchKSmRqLkN7FSj83YarJaZBA4gSshF6nUEd6Mqw5dTgjL7xDSWpmcHBQhczZYbyHxbMjoj7kDjtE9gJF6XDtftQz3js36ffg4J3EKepmQm5hSUoSP5Cfqc?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
  {
    resultId: 18,
    result: "Sennheiser IE 300",
    price: "$200",
    imgURL: "https://media.wired.com/photos/619bf53a8c0a4823ca2e0732/4:3/w_600",
    url: "https://cna.st/affiliate-link/21ph1kqPR9pEbA6BmLCDEyTdtFmoSAdaQUn8phkjGmN4eZY3H2qJZjERs4f5ovfL9v27dyFechKMxjSthh2uSrirm87cfek3F85rSEPRKEjZXitAGJb1J8jmnDiYBV5AZaLVwbUnXdrHBxZ6?cid=618c00090c47ce1547c65368",
    retailer: "amazon",
  },
]
